import { render, staticRenderFns } from "./BusCompanyList.vue?vue&type=template&id=0b9f4b2a&"
import script from "./BusCompanyList.vue?vue&type=script&lang=js&"
export * from "./BusCompanyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports